module.exports = __webpack_public_path__ + "static/media/tail-right.66d71d4c.svg";